import type { TranslationDictionary } from "./types";

export const VI_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Mới",
    "app.newTaskAria": "Trò chuyện mới",
    "sidebar.searchPlaceholder": "Tìm kiếm lời nhắc hoặc ID nhiệm vụ",
    "sidebar.filters": "Bộ lọc tác vụ",
    "sidebar.allRatios": "Tất cả các tỷ lệ",
    "sidebar.allOrientations": "Tất cả các định hướng",
    "sidebar.allModes": "Tất cả các chế độ",
    "sidebar.allResolutions": "Tất cả các nghị quyết",
    "sidebar.activeTasks": "Nhiệm vụ đang hoạt động",
    "sidebar.topAnchors": "Điều hướng thời gian hàng đầu",
    "sidebar.bottomAnchors": "Điều hướng thời gian dưới cùng",
    "sidebar.resize": "Thay đổi kích thước thanh bên",
    "batch.selected": "0 đã chọn",
    "batch.selectedCount": "đã chọn {count}",
    "batch.archivedCount": "Đã lưu trữ {count} cuộc trò chuyện",
    "batch.archiveFailed": "Lưu trữ hàng loạt không thành công",
    "batch.runningCannotDeleteSelected": "Các cuộc trò chuyện đã chọn đang chạy và không thể xóa được",
    "batch.deleteTitle": "Xóa {count} cuộc trò chuyện?",
    "batch.deleteMessage": "Điều này cũng sẽ xóa các tập tin hình ảnh cục bộ.",
    "batch.deleteSkippedDetail": "{count} tác vụ đang chạy sẽ được giữ nguyên",
    "batch.deleteSkippedSuffix": ", {count} tác vụ đang chạy không bị xóa",
    "batch.deletedCount": "Đã xóa {count} cuộc trò chuyện{skipped}",
    "batch.deleteFailed": "Xóa hàng loạt không thành công",
    "action.archive": "Lưu trữ",
    "action.delete": "Xóa",
    "action.cancel": "Hủy bỏ",
    "action.edit": "Chỉnh sửa",
    "action.clear": "Xóa",
    "action.paste": "Dán",
    "action.find": "Tìm kiếm",
    "action.replace": "Thay thế",
    "action.close": "Đóng",
    "action.confirm": "Xác nhận",
    "action.confirmQuestion": "Xác nhận hành động?",
    "action.refresh": "Làm mới",
    "action.save": "Cứu",
    "action.add": "Thêm vào",
    "action.new": "Mới",
    "action.import": "Nhập",
    "action.export": "Xuất",
    "queue.empty": "Không có hàng đợi",
    "queue.emptyAria": "Trạng thái hàng đợi: không có nhiệm vụ xếp hàng",
    "queue.jumpTitle": "Chuyển đến nhiệm vụ đang hoạt động",
    "queue.emptyTitle": "Không có nhiệm vụ xếp hàng đợi",
    "queue.channel": "Kênh {count}",
    "queue.availableChannels": "Các kênh có sẵn {usable}/{total}",
    "queue.dispatching": "Đang sắp xếp · đang chờ {waiting}",
    "queue.runningWaiting": "Đang chạy {running} · chờ đợi {waiting}",
    "queue.statusLabel": "Trạng thái hàng đợi: {text} · {channelText}.",
    "queue.runningActions": "Chạy hành động hàng đợi nhiệm vụ",
    "queue.waitingActions": "Đang chờ hành động xếp hàng nhiệm vụ",
    "queue.cancelRunning": "Hủy bỏ",
    "queue.cancelRunningTitle": "Hủy tác vụ đang chạy",
    "queue.dragWaiting": "Kéo để sắp xếp lại nhiệm vụ đang chờ",
    "queue.dragSort": "Kéo để sắp xếp",
    "queue.moveUp": "Hướng lên",
    "queue.moveUpTitle": "Di chuyển nhiệm vụ đang chờ lên",
    "queue.moveDown": "Xuống",
    "queue.moveDownTitle": "Di chuyển nhiệm vụ đang chờ xuống",
    "queue.promote": "Đứng đầu",
    "queue.promoteTitle": "Di chuyển nhiệm vụ đang chờ lên trên cùng",
    "queue.promoteFailed": "Di chuyển lên đầu không thành công",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Xóa nhiệm vụ đang chờ",
    "queue.deleteWaitingTitleConfirm": "Xóa nhiệm vụ đang chờ?",
    "queue.deleteWaitingMessage": "Điều này loại bỏ nó khỏi danh sách hàng đợi và lịch sử.",
    "queue.deleteQueuedFailed": "Không thể xóa tác vụ đã xếp hàng đợi",
    "queue.queuedDeleted": "Đã xóa tác vụ xếp hàng đợi",
    "queue.cancelRunningConfirm": "Hủy tác vụ",
    "queue.cancelRunningTitleConfirm": "Hủy tác vụ đang chạy?",
    "queue.cancelRunningMessage": "Nhiệm vụ hiện tại sẽ dừng lại.",
    "queue.cancelRunningFailed": "Không hủy được nhiệm vụ",
    "queue.runningCancelled": "Nhiệm vụ đã bị hủy",
    "queue.reorderFailed": "Không thể sắp xếp lại hàng đợi",
    "queue.realtimeUpdateFailed": "Không cập nhật được trạng thái trực tiếp",
    "queue.realtimeDisconnected": "Kết nối trạng thái trực tiếp bị mất.",
    "queue.readFailed": "Không thể tải hàng đợi",
    "status.waiting": "Chờ",
    "status.shownActiveTasks": "Hiển thị các tác vụ đang hoạt động",
    "status.jsonCopied": "Đã sao chép JSON",
    "taskStatus.submitting": "Đang gửi",
    "taskStatus.running": "Đang tạo",
    "taskStatus.runningWithElapsed": "Đang tạo · {elapsed}",
    "taskStatus.completed": "Hoàn thành",
    "taskStatus.partialFailed": "Thất bại một phần",
    "taskStatus.failed": "Thất bại",
    "taskStatus.queued": "Đã xếp hàng",
    "taskStatus.unknown": "Trạng thái không xác định",
    "taskStatus.task": "Nhiệm vụ",
    "taskStatus.connectionInterrupted": "Kết nối bị gián đoạn",
    "taskStatus.lastFailed": "Thất bại lần cuối",
    "taskStatus.waitingRetry": "{reason}, đang chờ thử lại (cố gắng {attempt}/{max})",
    "taskStatus.retrying": "{reason}, đang thử lại (lần {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Đã thử {attempt}/{max}, không thể thử lại",
    "taskStatus.manualRetryAvailable": "Đã dừng lại;",
    "taskStatus.waitingRetryShort": "Đang chờ thử lại",
    "taskStatus.retryingShort": "Đang thử lại",
    "taskStatus.nonRetryableShort": "Không thể thử lại",
    "taskStatus.manualRetryShort": "Thử lại thủ công",
    "taskStatus.stoppedShort": "Đã dừng",
    "taskStatus.runtime": "Thời lượng {duration}",
    "taskStatus.runtimeCompleted": "Thời lượng {duration} · đã hoàn thành {time}",
    "taskStatus.completedAt": "Hoàn thành lúc {time}",
    "taskCard.count": "{count} hình ảnh",
    "taskCard.successCount": "đã thành công {count}",
    "taskCard.failedCount": "thất bại {count}",
    "taskCard.runningCount": "tạo ra {count}",
    "taskCard.waitingCount": "đang chờ đợi {count}",
    "taskCard.textToImageThumb": "Hình thu nhỏ tác vụ chuyển văn bản thành hình ảnh",
    "taskCard.imageToImageThumb": "Hình thu nhỏ tác vụ chuyển hình ảnh thành hình ảnh",
    "taskCard.failedThumb": "Nhiệm vụ thất bại",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Biên tập",
    "taskMode.generate": "Phát ra",
    "document.generatingQueue": "Đang tạo · hàng đợi {total}",
    "document.queuedWaiting": "Đã xếp hàng · đang chờ {count}",
    "runFeedback.editing": "Chỉnh sửa",
    "runFeedback.generating": "Đang tạo",
    "runFeedback.status": "{action}, đã trôi qua {elapsed}",
    "footer.archive": "Lưu trữ",
    "footer.archiveCount": "Lưu trữ {count}",
    "footer.historyLibrary": "Lịch sử",
    "historyLibrary.openFull": "Mở thư viện lịch sử đầy đủ",
    "history.documentTitle": "Lịch sử - AGENTRA IMAGE",
    "history.back": "Quay lại AGENTRA IMAGE",
    "history.title": "Lịch sử",
    "history.loading": "Đang tải",
    "history.total": "{total} nhiệm vụ · {archived} đã lưu trữ",
    "history.search": "Tìm kiếm",
    "history.searchPlaceholder": "Tìm kiếm lời nhắc hoặc ID nhiệm vụ",
    "history.clear": "Xóa",
    "history.month": "Tháng",
    "history.status": "Trạng thái",
    "history.promptMode": "Chế độ nhắc nhở",
    "history.size": "Kích cỡ",
    "history.quality": "Chất lượng",
    "history.ratio": "Tỷ lệ",
    "history.orientation": "Định hướng",
    "history.backend": "Backend",
    "history.provider": "Nhà cung cấp",
    "history.archived": "Đã lưu trữ",
    "history.all": "Tất cả",
    "history.allMonths": "Tất cả các tháng",
    "history.allStatuses": "Tất cả trạng thái",
    "history.allPromptModes": "Tất cả các chế độ",
    "history.allSizes": "Tất cả các kích cỡ",
    "history.allQualities": "Mọi phẩm chất",
    "history.allRatios": "Tất cả các tỷ lệ",
    "history.ratioOther": "Khác",
    "history.allOrientations": "Tất cả các định hướng",
    "history.allBackends": "Tất cả phụ trợ",
    "history.allProviders": "Tất cả các nhà cung cấp",
    "history.unarchived": "Chưa được lưu trữ",
    "history.archivedOnly": "Đã lưu trữ",
    "history.tasksAria": "Nhiệm vụ lịch sử",
    "history.taskListTitle": "Nhiệm vụ lịch sử",
    "history.browseNewest": "Duyệt mới nhất trước",
    "history.view": "Xem",
    "history.grid": "Lưới",
    "history.list": "Danh sách",
    "history.sort": "Loại",
    "history.newest": "Mới nhất đầu tiên",
    "history.oldest": "Cũ nhất đầu tiên",
    "history.refresh": "Làm mới",
    "history.selectedCount": "Đã chọn {count} nhiệm vụ",
    "history.confirmDelete": "Xác nhận xóa",
    "history.detail": "Chi tiết nhiệm vụ",
    "history.detailTitle": "Nhiệm vụ lịch sử",
    "history.closeDetail": "Đóng chi tiết nhiệm vụ",
    "history.resizeFilters": "Thay đổi kích thước thanh bên bộ lọc",
    "history.resizeDetail": "Thay đổi kích thước ngăn chi tiết",
    "history.detailEmpty": "Chọn một nhiệm vụ lịch sử để xem chi tiết",
    "history.loadingDetail": "Đang tải chi tiết...",
    "history.loadMore": "Tải thêm",
    "history.loadingMore": "Đang tải...",
    "history.noMore": "Không còn nhiệm vụ nào nữa",
    "history.loadFailed": "Tải không thành công.",
    "history.summaryFailed": "Không tải được bản tóm tắt",
    "history.tasksFailed": "Không tải được nhiệm vụ",
    "history.detailFailed": "Không thể tải chi tiết",
    "history.noMatches": "Không có nhiệm vụ phù hợp",
    "history.loadedCount": "Đã tải {count}",
    "history.windowNotice": "Danh sách được gắn được giới hạn ở các tác vụ {count};",
    "history.selectTask": "Chọn nhiệm vụ",
    "history.viewing": "Đang xem",
    "history.noPreview": "Không có hình ảnh xem trước",
    "history.downloadAll": "Tải xuống ZIP",
    "history.downloadSelected": "Đã chọn tải xuống",
    "history.deleteUnselected": "Xóa không được chọn",
    "history.confirmDeleteUnselected": "Xác nhận xóa bỏ chọn",
    "history.selected": "Đã chọn",
    "history.select": "Lựa chọn",
    "history.downloadIndex": "Tải xuống {index}",
    "history.addReference": "Thêm tài liệu tham khảo",
    "history.outputActions": "Hành động hình ảnh kết quả",
    "history.inputReferences": "Tham chiếu đầu vào",
    "history.inputReferenceIndex": "Tham chiếu đầu vào {index}",
    "history.copyPrompt": "Sao chép lời nhắc",
    "history.copyPrompts": "Sao chép lời nhắc",
    "history.copyPromptShort": "Sao chép",
    "history.copyPromptPanel": "Sao chép {title}",
    "history.copyOutputPromptPanel": "Sao chép hình ảnh {index} lời nhắc sửa đổi",
    "history.copyTaskIds": "Sao chép ID tác vụ",
    "history.reuseTask": "Xem trong trình tạo",
    "history.downloadTask": "Tải xuống",
    "history.downloadSelectedTasks": "Tải xuống hàng loạt",
    "history.contextMenuLabel": "Menu ngữ cảnh nhiệm vụ lịch sử",
    "history.promptCopied": "Đã sao chép lời nhắc",
    "history.promptsCopied": "Đã sao chép lời nhắc từ tác vụ {count}",
    "history.taskIdsCopied": "Đã sao chép {count} ID tác vụ",
    "history.promptCopiedShort": "Đã sao chép",
    "history.promptCopyFailed": "Không sao chép được lời nhắc",
    "history.promptCopyFailedShort": "Thất bại",
    "history.noPrompt": "Tác vụ này không có lời nhắc sao chép",
    "history.noPromptShort": "Trống",
    "history.downloadStarted": "Đã bắt đầu tải xuống",
    "history.batchDownloadStarted": "Đã bắt đầu tải xuống cho tác vụ {count}",
    "history.noDownloadableOutputs": "Không có hình ảnh có thể tải xuống",
    "history.confirmDeleteSelected": "Xác nhận đã chọn xóa",
    "history.openPreview": "Mở bản xem trước",
    "history.closePreview": "Đóng bản xem trước",
    "history.untitled": "Không có tiêu đề",
    "history.promptCompare": "So sánh nhanh chóng",
    "history.promptOriginal": "Lời nhắc ban đầu",
    "history.promptSubmitted": "Lời nhắc được tối ưu hóa",
    "history.promptRevised": "Kết quả sửa đổi",
    "history.outputRevisedPromptTitle": "Lời nhắc sửa đổi hình ảnh {index}",
    "history.outputRevisedPromptNotice": "Mỗi hình ảnh có lời nhắc sửa đổi riêng bên dưới hình ảnh.",
    "history.promptEmpty": "Không có nội dung",
    "history.promptMode.strict": "Nghiêm ngặt",
    "history.promptMode.original": "Nguyên bản",
    "history.promptMode.off": "Sáng tạo",
    "history.quality.high": "Cao",
    "history.quality.medium": "Cân bằng",
    "history.quality.low": "Nhanh",
    "history.quality.auto": "Tự động",
    "footer.batch": "Hàng loạt",
    "footer.storage": "Kho",
    "footer.apiStatus": "Trạng thái API: OK",
    "footer.version": "Phiên bản {version}",
    "footer.versionInfo": "Thông tin phiên bản",
    "footer.versionLoading": "Phiên bản ...",
    "footer.updateBadge": "Đã có phiên bản mới",
    "footer.updateAvailable": "Phiên bản mới {version}",
    "version.title": "Phiên bản & Cập nhật",
    "version.loading": "Đọc trạng thái phiên bản",
    "version.current": "Phiên bản hiện tại",
    "version.latest": "Phiên bản mới nhất",
    "version.source": "Thời gian chạy",
    "version.sourcePortable": "Gói di động",
    "version.sourceSource": "Kiểm tra nguồn",
    "version.upToDate": "Bạn đã ở phiên bản mới nhất",
    "version.updateAvailable": "Đã có phiên bản {version}.",
    "version.noUpdater": "Thời gian chạy này không phải là gói di động nên trình cập nhật không thể tự động khởi động.",
    "version.openUpdater": "Bắt đầu cập nhật",
    "version.release": "Xem bản phát hành",
    "version.updaterStarted": "Trình cập nhật đã bắt đầu.",
    "version.updaterFailed": "Không thể khởi động trình cập nhật.",
    "notifications.title": "Thông báo",
    "notifications.unread": "Thông báo, {count} chưa đọc",
    "notifications.unreadSummary": "{count} chưa đọc",
    "notifications.empty": "Không có thông báo nhiệm vụ",
    "notifications.taskFailed": "Nhiệm vụ thất bại",
    "notifications.taskPartial": "Nhiệm vụ đã hoàn thành một phần",
    "notifications.taskCompleted": "Nhiệm vụ đã hoàn thành",
    "notifications.generationFailed": "Thế hệ không thành công",
    "notifications.successCount": "{count} đã thành công",
    "notifications.resultAvailable": "Kết quả có sẵn",
    "notifications.failedCount": "{count} không thành công",
    "notifications.systemUnsupported": "Trình duyệt này không hỗ trợ thông báo hệ thống",
    "notifications.systemBlocked": "Thông báo hệ thống bị trình duyệt chặn.",
    "notifications.systemDenied": "Thông báo hệ thống chưa được bật",
    "notifications.systemEnabled": "Đã bật thông báo hệ thống",
    "notifications.taskMissing": "Tác vụ không tồn tại hoặc đã bị xóa",
    "theme.label": "Chủ đề",
    "theme.system": "Tự động",
    "theme.light": "Sáng",
    "theme.dark": "Tối",
    "language.label": "Ngôn ngữ giao diện",
    "language.zh": "中",
    "language.zhCN": "Tiếng Trung giản thể",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "Tiếng Anh",
    "language.es": "tiếng Tây Ban Nha",
    "language.pt": "người Bồ Đào Nha",
    "language.fr": "người Pháp",
    "language.de": "tiếng Đức",
    "language.ru": "Русский",
    "language.it": "tiếng Ý",
    "language.hi": "हिन्दी",
    "auth.label": "Nguồn xác thực",
    "auth.checking": "Kiểm tra xác thực",
    "auth.missingCodexSession": "Không phát hiện thấy phiên Codex nào",
    "auth.switchFailed": "Không thể chuyển đổi nguồn xác thực",
    "auth.sourceUnavailable": "{source} không có sẵn",
    "auth.notActive": "Không hoạt động",
    "auth.loginPrompt": "Codex chưa đăng nhập. Bạn có muốn mở đăng nhập Codex ngay không?",
    "auth.loginStarted": "Đang mở đăng nhập Codex. Hãy hoàn tất đăng nhập trong trình duyệt...",
    "auth.loginCompleted": "Đăng nhập Codex thành công",
    "auth.loginStartFailed": "Không thể mở đăng nhập Codex",
    "auth.loginTimedOut": "Chưa phát hiện đăng nhập Codex. Hãy hoàn tất đăng nhập rồi bấm lại Codex.",
    "api.settings": "Cài đặt hệ thống",
    "api.provider": "nhà cung cấp API",
    "imageInput.title": "Hình ảnh",
    "imageInput.uploadAria": "Nhấp, thả hoặc dán hình ảnh",
    "imageInput.uploadFull": "Nhấp, thả hoặc dán hình ảnh",
    "imageInput.uploadCompact": "Thêm hình ảnh",
    "imageInput.uploadSubtitle": "Hỗ trợ nhiều hình ảnh tham khảo",
    "imageInput.recent": "Tải lên gần đây",
    "imageInput.recentBadge": "Gần đây",
    "imageInput.uploadBadge": "Tải lên",
    "imageInput.addToGallery": "Thêm vào thư viện",
    "imageInput.addToGalleryShort": "Phòng trưng bày",
    "imageInput.removeImage": "Xóa hình ảnh",
    "imageInput.editedBadge": "Đã chỉnh sửa",
    "imageInput.editImage": "Chỉnh sửa {name}",
    "imageInput.deletedRecent": "Đã xóa nội dung tải lên gần đây",
    "imageInput.deletedGallery": "Đã xóa hình ảnh thư viện",
    "recentAssets.defaultName": "Tải lên gần đây",
    "recentAssets.use": "Sử dụng {name}",
    "recentAssets.delete": "Xóa {name}",
    "recentAssets.deleteTitle": "Xóa nội dung tải lên gần đây?",
    "recentAssets.deleteMessage": "Thao tác này sẽ xóa hình ảnh khỏi các ảnh tải lên gần đây.",
    "recentAssets.loadFailed": "Không tải được các video tải lên gần đây",
    "recentAssets.deleteFailed": "Không xóa được nội dung tải lên gần đây",
    "recentAssets.deleted": "Đã xóa nội dung tải lên gần đây",
    "inputSource.uploadFallback": "Hình ảnh đã tải lên",
    "inputSource.galleryFallback": "Hình ảnh thư viện",
    "inputSource.focusPasteFallback": "{prefix}. Ô nhập ảnh đang được chọn; nhấn {shortcut} để dán ảnh.",
    "inputSource.pastedCount": "Đã dán {count} hình ảnh trong bảng nhớ tạm",
    "inputSource.droppedCount": "Đã thêm {count} hình ảnh bị rơi",
    "inputSource.dropImagesOnly": "Chỉ thả tập tin hình ảnh",
    "inputSource.clipboardUnsupported": "Trình duyệt này không thể đọc clipboard trực tiếp",
    "inputSource.clipboardEmpty": "Không tìm thấy hình ảnh clipboard",
    "inputSource.clipboardDenied": "Trình duyệt đã chặn truy cập clipboard trực tiếp",
    "inputSource.clipboardReadFailed": "Không đọc được bảng nhớ tạm",
    "status.missingGalleryReference": "Một hình ảnh tham khảo thư viện đã bị xóa.",
    "status.missingRecentReference": "Hình ảnh tham chiếu tải lên gần đây đã bị xóa.",
    "status.emptyPrompt": "Nhập lời nhắc",
    "status.editNeedsImage": "Chế độ chỉnh sửa yêu cầu ít nhất một hình ảnh",
    "status.loadedTask": "Đã tải tác vụ {taskId}",
    "status.reusedTask": "Đã mở tác vụ {taskId} trong trình tạo",
    "status.loadingHistoryInputs": "Đang tải hình ảnh đầu vào lịch sử...",
    "status.historyInputLoadFailed": "Không tải được hình ảnh đầu vào lịch sử: {url}",
    "referenceCollector.alreadyStaged": "Đã được dàn dựng làm tài liệu tham khảo",
    "referenceCollector.staged": "Hình ảnh tham khảo {count} được dàn dựng",
    "referenceCollector.title": "Tài liệu tham khảo đang chờ xử lý · {count}",
    "referenceCollector.addAll": "Thêm tất cả tài liệu tham khảo",
    "referenceCollector.itemFallback": "Đang chờ tham chiếu",
    "referenceCollector.remove": "Xóa tham chiếu đang chờ xử lý",
    "referenceCollector.cleared": "Đã xóa các tham chiếu đang chờ xử lý",
    "referenceCollector.added": "Đã thêm hình ảnh tham khảo {count}",
    "referenceCollector.addFailed": "Không thể thêm tài liệu tham khảo đang chờ xử lý",
    "referenceCollector.readFailed": "Không đọc được hình ảnh: {status}",
    "gallery.quick": "Thư viện nhanh",
    "gallery.current": "Thư viện danh mục hiện tại",
    "gallery.categories": "Danh mục thư viện",
    "gallery.categoryPortrait": "Chân dung",
    "gallery.categoryCharacter": "Nhân vật",
    "gallery.categoryProduct": "Sản phẩm",
    "gallery.categoryPortraitRole": "Tham chiếu chân dung",
    "gallery.categoryCharacterRole": "Tham chiếu nhân vật",
    "gallery.categoryProductRole": "Tham khảo sản phẩm",
    "gallery.referenceRole": "Hình ảnh tham khảo",
    "gallery.manage": "Quản lý thư viện",
    "gallery.loadFailed": "Không tải được thư viện",
    "gallery.imageOrderUpdateFailed": "Không thể cập nhật thứ tự hình ảnh",
    "gallery.imageOrderUpdated": "Đã cập nhật thứ tự hình ảnh",
    "gallery.categoryName": "Tên danh mục",
    "gallery.categoryPromptRole": "Vai trò của lời nhắc",
    "gallery.categorySave": "Lưu",
    "gallery.categoryDelete": "Xóa",
    "gallery.categoryLoadFailed": "Không thể tải danh mục",
    "gallery.categoryNameRequired": "Nhập tên danh mục",
    "gallery.categoryCreateFailed": "Không thể thêm danh mục",
    "gallery.categoryCreated": "Đã thêm danh mục",
    "gallery.categorySaveFailed": "Không lưu được danh mục",
    "gallery.categorySaved": "Đã lưu danh mục",
    "gallery.categoryDeleteTitle": "Xóa danh mục thư viện?",
    "gallery.categoryDeleteMessage": "Hình ảnh trong danh mục này sẽ chuyển sang danh mục khác.",
    "gallery.categoryDeleteConfirm": "Xóa danh mục",
    "gallery.categoryDeleteFailed": "Không thể xóa danh mục",
    "gallery.categoryDeletedMigrated": "Đã xóa danh mục \"{name}\" và di chuyển hình ảnh",
    "gallery.categoryOrderUpdateFailed": "Không thể cập nhật thứ tự danh mục",
    "gallery.categoryOrderUpdated": "Đã cập nhật thứ tự danh mục",
    "gallery.categoryFallback": "Danh mục thư viện",
    "gallery.imageFallback": "Hình ảnh thư viện",
    "gallery.imageLoadFailed": "Không thể tải hình ảnh này",
    "gallery.editImageLoadFailed": "Không thể tải hình ảnh này để chỉnh sửa",
    "gallery.cannotAddImage": "Không thể thêm hình ảnh này vào thư viện",
    "gallery.nameRequired": "Nhập tên thư viện",
    "gallery.saveFailed": "Không lưu được hình ảnh thư viện",
    "gallery.savedAsReference": "Đã thêm vào thư viện và chuyển sang tham chiếu thư viện",
    "gallery.renameImage": "Đổi tên hình ảnh thư viện",
    "gallery.moveToCategory": "Chuyển đến danh mục",
    "gallery.categoryRequired": "Chọn danh mục thư viện",
    "gallery.promptNoteTitle": "Ghi chú tham khảo thư viện",
    "gallery.updateFailed": "Không cập nhật được thư viện",
    "gallery.selectImageFile": "Chọn một tập tin hình ảnh",
    "gallery.replaceImageFailed": "Không thể thay thế hình ảnh thư viện",
    "gallery.replacedImage": "Đã thay thế hình ảnh nguồn cho \"{name}\"",
    "gallery.deleteImageTitle": "Xóa hình ảnh thư viện?",
    "gallery.deleteImageMessage": "Các tham chiếu nhiệm vụ lịch sử sẽ hiển thị là đã bị xóa.",
    "gallery.deleteFailed": "Không thể xóa hình ảnh thư viện",
    "gallery.deletedSuffix": "(đã xóa)",
    "gallery.editImageLabel": "Chỉnh sửa hình ảnh thư viện",
    "gallery.fieldCategory": "Loại",
    "gallery.fieldPromptNote": "Ghi chú tham khảo",
    "gallery.fieldName": "Tên",
    "quickGallery.empty": "Chưa có hình ảnh {category}",
    "promptGallery.remove": "Xóa @{name}",
    "prompt.title": "Lời nhắc",
    "prompt.editorLabel": "Lời nhắc",
    "prompt.placeholder": "Mô tả hình ảnh bạn muốn tạo hoặc chỉnh sửa.",
    "prompt.run": "Tạo ảnh",
    "prompt.runEdit": "Tạo ảnh",
    "prompt.runTitle": "Bắt đầu tạo ảnh (Cmd+Enter)",
    "prompt.runEditTitle": "Tạo ảnh từ ảnh tham khảo (Cmd+Enter)",
    "prompt.findPanel": "Lời nhắc tìm và thay thế",
    "prompt.findText": "Tìm văn bản",
    "prompt.replaceWith": "Thay thế bằng",
    "prompt.findActions": "Hành động tìm và thay thế",
    "prompt.countZero": "0 trận đấu",
    "prompt.matchCount": "{count} trận đấu",
    "prompt.foundCount": "Đã tìm thấy {count} kết quả phù hợp",
    "prompt.noMatch": "Không có văn bản phù hợp",
    "prompt.replacedCount": "Đã thay thế {count} kết quả phù hợp",
    "prompt.closeFind": "Đóng tìm và thay thế",
    "prompt.recentTemplates": "Mẫu gần đây",
    "prompt.manageTemplates": "Quản lý mẫu",
    "promptModel.galleryHeader": "Ghi chú hình ảnh tham khảo:",
    "promptModel.galleryInstruction": "- Hình ảnh tham khảo {number}: thư viện \"{name}\", vai trò: {role}. {name} {note}",
    "outputSettings.title": "Đầu ra",
    "output.mainModel": "Mô hình chính",
    "output.selectMainModel": "Chọn mô hình chính",
    "output.mainModelCustomForInput": "Sử dụng mô hình tùy chỉnh cho đầu vào hiện tại",
    "output.apiDirect": "API trực tiếp",
    "output.apiToolModel": "Sử dụng mô hình hình ảnh API",
    "output.mainModelUnused": "Mô hình chính không được sử dụng cho yêu cầu này",
    "output.webSearch": "Tìm kiếm trên web",
    "output.webSearchToggle": "Bật",
    "output.webSearchTitle": "Tìm kiếm trên web trước rồi dùng kết quả cho lần tạo ảnh này; chỉ khả dụng với kênh Responses",
    "output.promptMode": "Chế độ nhắc nhở",
    "output.optimizationStyle": "Phong cách tối ưu",
    "output.optimizationNone": "Mặc định",
    "output.optimizationPortrait": "Chân dung chân thực",
    "output.optimizationProduct": "Sản phẩm",
    "output.optimizationFashion": "Thời trang",
    "output.optimizationCreative": "Sáng tạo",
    "output.optimizationHint": "Chỉ bổ sung chỉ dẫn thẩm mỹ khi bạn chọn một phong cách.",
    "output.modeOriginal": "Nguyên bản",
    "output.modeStrict": "Giữ nguyên",
    "output.modeCreative": "Sáng tạo",
    "output.sizeMode": "Chế độ kích thước",
    "output.sizePreset": "Đặt trước",
    "output.sizeCustom": "Tùy chỉnh",
    "output.orientation": "Hướng",
    "output.square": "Vuông",
    "output.portrait": "Chân dung",
    "output.landscape": "Ngang",
    "output.resolution": "Kích thước ảnh",
    "output.pixelSize": "Kích thước pixel",
    "output.width": "Chiều rộng",
    "output.height": "Chiều cao",
    "output.swapSize": "Hoán đổi chiều rộng và chiều cao",
    "output.customSizeHint": "Đơn vị px · 16-3840 · bội số của 16 · 3:1",
    "output.imageSizeUnavailable": "Kích thước hình ảnh không có sẵn",
    "output.imageLoadFailed": "Không tải được hình ảnh",
    "output.customSizeRequired": "Nhập chiều rộng và chiều cao",
    "output.customSizeBounds": "Chiều rộng và chiều cao phải là 16-3840 px",
    "output.customSizeMultiple": "Chiều rộng và chiều cao phải là bội số của 16",
    "output.customSizeRatio": "Tỷ lệ cạnh dài và ngắn không được vượt quá 3:1",
    "output.customSizePixels": "Tổng số pixel phải là 655.360-8.294.400",
    "output.ratioLock": "Khóa tỷ lệ (tùy chọn)",
    "output.customRatio": "Tỷ lệ khung hình tùy chỉnh",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Sử dụng tỷ lệ khung hình của hình ảnh tham chiếu đầu tiên",
    "output.useFirstImage": "Từ hình ảnh",
    "output.ratioHint": "Để trống đối với kích thước miễn phí · Điền cả hai để đồng bộ hóa",
    "output.ratio": "Tỷ lệ",
    "output.quality": "Mức render",
    "output.qualityAuto": "Tự động",
    "output.qualityLow": "Nhanh",
    "output.qualityMedium": "Cân bằng",
    "output.qualityHigh": "Cao",
    "output.quantity": "Đếm",
    "output.pixelPreview": "Pixel đầu ra: 1024 x 1024 px",
    "output.pixelPreviewValue": "Pixel đầu ra: {value}",
    "output.pixelPreviewAuto": "Pixel đầu ra: tự động (OpenAI chọn tự động)",
    "output.format": "Định dạng",
    "output.compression": "nén",
    "output.moderation": "Kiểm duyệt",
    "preview.title": "Xem trước",
    "preview.selectedZero": "0 đã chọn",
    "preview.selectedCount": "Đã chọn {selected}/{total}",
    "preview.downloadSelected": "Tải xuống mục đã chọn",
    "preview.deleteUnselected": "Xóa mục chưa chọn",
    "preview.downloadAll": "Tải xuống ZIP",
    "preview.empty": "Chưa có hình ảnh nào",
    "preview.taskFailed": "Nhiệm vụ thất bại",
    "preview.partialFailed": "Một số hình ảnh không thành công",
    "preview.failedOutput": "Hình ảnh {index} không thành công",
    "preview.progressLine": "Đã hoàn thành {generated} / {total} · đã trôi qua {elapsed}",
    "preview.failureLine": "Đã hoàn thành {generated} / {total} · thất bại {failed}",
    "preview.elapsedLine": "Đã trôi qua {elapsed}",
    "preview.lastError": "Lỗi cuối cùng: {error}",
    "preview.continueGenerating": "Tiếp tục tạo",
    "preview.waitingContinue": "Đang chờ tiếp tục",
    "preview.retryFailed": "Thử lại hình ảnh không thành công",
    "preview.acceptSuccesses": "Chấp nhận kết quả thành công",
    "preview.generateMode": "Tạo ảnh",
    "preview.editMode": "Chỉnh sửa",
    "preview.runningTitle": "{mode} đang chạy",
    "preview.submittingTitle": "Đang gửi nhiệm vụ",
    "preview.queuedTitle": "Nhiệm vụ được xếp hàng đợi",
    "preview.submittingDetail": "Lưu đầu vào và thêm tác vụ vào hàng đợi.",
    "preview.queuedDetail": "Tác vụ đang ở trong hàng đợi và đang chờ kênh khả dụng.",
    "preview.featured": "Đã chọn",
    "preview.addFeatured": "Chọn kết quả",
    "preview.selectedFeatured": "Đã chọn",
    "preview.removeFeatured": "Bỏ chọn kết quả",
    "preview.selectionAdded": "Đã chọn kết quả",
    "preview.selectionRemoved": "Đã bỏ chọn kết quả",
    "preview.selectionUpdateFailed": "Không thể cập nhật lựa chọn",
    "preview.noUnselectedOutputs": "Không có hình ảnh nào được chọn để xóa",
    "preview.deleteUnselectedTitle": "Xóa hình ảnh không được chọn?",
    "preview.deleteUnselectedMessage": "Thao tác này sẽ xóa các tệp hình ảnh cục bộ đối với các kết quả không được chọn trong tác vụ này.",
    "preview.deleteUnselectedDetail": "Giữ {selected}, xóa {deleted}",
    "preview.deleteUnselectedFailed": "Không thể xóa hình ảnh không được chọn",
    "preview.deleteUnselectedDone": "Đã xóa hình ảnh không được chọn",
    "preview.addReference": "Thêm tài liệu tham khảo",
    "preview.stage": "Đưa vào chờ",
    "preview.stageReference": "Đưa thành ảnh tham chiếu đang chờ",
    "preview.prompt": "Lời nhắc",
    "preview.download": "Tải xuống",
    "preview.downloadImage": "Tải xuống hình ảnh này",
    "lightbox.label": "Xem trước hình ảnh",
    "lightbox.close": "Đóng bản xem trước",
    "lightbox.previous": "Hình ảnh trước đó",
    "lightbox.next": "Hình ảnh tiếp theo",
    "promptPopover.title": "So sánh nhanh chóng",
    "promptPopover.summary": "Bản gốc {original} · tối ưu {optimized}",
    "promptPopover.original": "Lời nhắc ban đầu",
    "promptPopover.optimized": "Lời nhắc được tối ưu hóa",
    "promptPopover.charCount": "{count} ký tự",
    "promptPopover.empty": "Không có",
    "promptPopover.notReturned": "Không được trả lại",
    "promptPopover.noOptimized": "Không có lời nhắc tối ưu hóa nào được trả về",
    "promptPopover.submitted": "Xem lời nhắc đã gửi",
    "promptPopover.close": "Đóng so sánh nhắc nhở",
    "promptPopover.copyOptimized": "Sao chép lời nhắc được tối ưu hóa",
    "promptPopover.copied": "Đã sao chép",
    "taskContext.menuLabel": "Menu ngữ cảnh nhiệm vụ",
    "taskContext.view": "Xem nhiệm vụ",
    "taskContext.copyId": "Sao chép ID tác vụ",
    "taskContext.copyPrompt": "Sao chép lời nhắc",
    "taskContext.revealOutput": "Mở thư mục đầu ra",
    "taskContext.archive": "Nhiệm vụ lưu trữ",
    "taskContext.delete": "Xóa tác vụ",
    "taskContext.idCopied": "Đã sao chép ID nhiệm vụ",
    "taskContext.promptCopied": "Đã sao chép lời nhắc",
    "taskContext.noPrompt": "Tác vụ này không có lời nhắc sao chép",
    "taskContext.revealFailed": "Không thể mở thư mục đầu ra",
    "taskContext.revealOpened": "Đã mở thư mục đầu ra",
    "taskContext.actionFailed": "Tác vụ không thành công",
    "taskActions.group": "Tác vụ tác vụ",
    "taskActions.deleteTitle": "Xóa nhiệm vụ?",
    "taskActions.deleteMessage": "Điều này cũng sẽ xóa các tập tin hình ảnh cục bộ.",
    "taskActions.runningCannotDelete": "Không thể xóa các tác vụ đang chạy",
    "taskActions.updated": "Đã cập nhật trạng thái nhiệm vụ",
    "taskActions.archived": "Đã lưu trữ cuộc trò chuyện",
    "taskActions.archiveFailed": "Lưu trữ không thành công",
    "taskActions.deleted": "Đã xóa tác vụ",
    "taskActions.deleteFailed": "Xóa không thành công",
    "taskActions.noRetryableFailedImages": "Tác vụ này không có hình ảnh nào bị lỗi để thử lại",
    "taskActions.retryFailedOutputsFailed": "Không thể thử lại các hình ảnh bị lỗi",
    "taskActions.requeuedFailedImages": "Hình ảnh bị lỗi được yêu cầu xếp hàng đợi",
    "taskActions.noAcceptableSuccessImages": "Nhiệm vụ này không có hình ảnh thành công nào để chấp nhận",
    "taskActions.acceptSuccessesFailed": "Không thể chấp nhận kết quả thành công",
    "taskActions.acceptedSuccesses": "Kết quả thành công được chấp nhận",
    "taskActions.viewedUpdateFailed": "Không cập nhật được trạng thái đọc",
    "taskActions.failedFallback": "Nhiệm vụ thất bại",
    "taskList.empty": "Chưa có lịch sử",
    "taskList.selectSession": "Chọn trò chuyện",
    "taskList.unreadUpdate": "Cập nhật chưa đọc",
    "taskList.viewing": "Đang xem",
    "taskDerived.usageLimited": "Hạn chế sử dụng",
    "taskSubmit.requestFailed": "Yêu cầu không thành công",
    "taskSubmit.queued": "Nhiệm vụ được thêm vào hàng đợi",
    "taskSubmit.timeout": "Việc gửi tác vụ đã hết thời gian trước khi chương trình phụ trợ phản hồi.",
    "taskSubmit.failed": "Gửi nhiệm vụ không thành công",
    "templates.title": "Mẫu lời nhắc",
    "templates.summary": "Thư viện mẫu cục bộ",
    "templates.availableCount": "{count} mẫu có sẵn",
    "templates.noMatch": "Không có mẫu phù hợp",
    "templates.empty": "Không có mẫu",
    "templates.favoriteBadge": "Yêu thích",
    "templates.usageCount": "{count} lần sử dụng",
    "templates.back": "Mặt sau",
    "templates.edit": "Chỉnh sửa",
    "templates.copy": "Sao chép",
    "templates.insert": "Chèn",
    "templates.formTitle": "Tiêu đề",
    "templates.formShortTitle": "Tiêu đề ngắn",
    "templates.formCategory": "Loại",
    "templates.formTags": "Thẻ",
    "templates.formThumbnail": "Hình thu nhỏ",
    "templates.formContent": "Nội dung",
    "templates.formNotes": "Ghi chú",
    "templates.formFavorite": "Yêu thích",
    "templates.thumbnailClear": "Thông thoáng",
    "templates.thumbnailNone": "Không có lựa chọn nào",
    "templates.thumbnailEmpty": "Không có hình thu nhỏ lịch sử",
    "templates.newCategory": "Danh mục mới",
    "templates.search": "Tìm kiếm mẫu, thẻ hoặc nội dung",
    "templates.filter": "Bộ lọc mẫu",
    "templates.all": "Tất cả",
    "templates.categoryCommon": "Chung",
    "templates.categoryPortrait": "Chân dung",
    "templates.categoryProduct": "Sản phẩm",
    "templates.categoryRepair": "Sửa chữa",
    "templates.categoryPoster": "Poster",
    "templates.categoryEcommerce": "Thương mại điện tử",
    "templates.favorite": "Yêu thích",
    "templates.recent": "Gần đây",
    "templates.category": "Danh mục",
    "templates.loadFailed": "Không tải được mẫu lời nhắc",
    "templates.useStateUpdateFailed": "Không cập nhật được trạng thái sử dụng mẫu lời nhắc",
    "templates.copied": "Đã sao chép mẫu lời nhắc",
    "templates.copyFailed": "Không sao chép được mẫu lời nhắc",
    "templates.history": "Lịch sử",
    "templates.saveFailed": "Không lưu được mẫu lời nhắc",
    "templates.saved": "Đã lưu mẫu lời nhắc",
    "templates.deleteFailed": "Không xóa được mẫu lời nhắc",
    "templates.deleted": "Đã xóa mẫu lời nhắc",
    "templates.categoryAddFailed": "Không thể thêm danh mục mẫu",
    "templates.categoryAdded": "Đã thêm danh mục mẫu",
    "templates.categorySaveFailed": "Không lưu được danh mục mẫu",
    "templates.categorySaved": "Đã lưu danh mục mẫu",
    "templates.categoryDeleteFailed": "Không thể xóa danh mục mẫu",
    "templates.categoryDeleted": "Đã xóa danh mục mẫu",
    "templates.importFailed": "Không thể nhập gói mẫu",
    "templates.importedCount": "Mẫu {count} đã nhập",
    "templates.exportFailed": "Không xuất được gói mẫu",
    "templates.exported": "Đã xuất gói mẫu",
    "snippets.suggestLabel": "Bộ chọn đoạn trích nhắc nhở",
    "snippets.saveSelection": "Cứu",
    "snippets.saveSelectionLabel": "Lưu văn bản đã chọn dưới dạng đoạn nhắc",
    "snippets.popoverLabel": "Đoạn trích nhắc nhở",
    "snippets.defaultCategory": "Chung",
    "snippets.loadFailed": "Không tải được đoạn lời nhắc",
    "snippets.remove": "Xóa ~{tag}",
    "snippets.expand": "Mở rộng",
    "snippets.edit": "Biên tập",
    "snippets.close": "Đóng",
    "snippets.editTitle": "Chỉnh sửa đoạn trích",
    "snippets.saveTitle": "Lưu đoạn trích",
    "snippets.shortTag": "Thẻ ngắn",
    "snippets.title": "Tiêu đề",
    "snippets.category": "Loại",
    "snippets.content": "Nội dung",
    "snippets.titlePlaceholder": "Sử dụng thẻ ngắn theo mặc định",
    "snippets.cancel": "Hủy bỏ",
    "snippets.save": "Cứu",
    "snippets.saveFailed": "Không lưu được đoạn lời nhắc",
    "snippets.saved": "Đã lưu đoạn lời nhắc",
    "snippets.defaultTag": "Đoạn thông thường",
    "colors.white": "Trắng",
    "colors.black": "Đen",
    "colors.warmBeige": "Màu be ấm",
    "colors.lightGreen": "Xanh nhạt",
    "colors.brandGreen": "Thương hiệu xanh",
    "colors.peachOrange": "Cam đào",
    "colors.lightBlue": "Màu xanh nhạt",
    "colors.lightPink": "Hồng nhạt",
    "colors.loadFailed": "Không tải được cài đặt màu",
    "colors.saveFailed": "Không lưu được cài đặt màu",
    "colors.importFailed": "Không thể nhập cài đặt màu",
    "colors.importedCount": "Đã nhập {count} màu",
    "colors.recentSaveFailed": "Không lưu được các màu gần đây",
    "colors.favoriteSaveFailed": "Không lưu được màu yêu thích",
    "colors.favoriteDeleteFailed": "Không xóa được màu yêu thích",
    "colors.update": "Cập nhật",
    "colors.insert": "Chèn",
    "colors.pick": "Chọn màu",
    "colors.pickShort": "Nhặt",
    "colors.hexValue": "Giá trị màu",
    "colors.pendingUpdate": "Màu sắc đã thay đổi.",
    "colors.save": "Cứu",
    "colors.exportPs": "Xuất khẩu",
    "colors.importPs": "Nhập khẩu",
    "colors.done": "Xong",
    "colors.manage": "Quản lý",
    "colors.favorites": "Màu sắc yêu thích",
    "colors.recent": "Màu sắc gần đây",
    "colors.recentLabel": "Gần đây",
    "colors.deleteFavorite": "Xóa màu yêu thích {name}",
    "colors.modify": "Chỉnh sửa màu",
    "colors.modifyValue": "Chỉnh sửa màu {value}",
    "colors.removeValue": "Xóa màu {value}",
    "taskGroup.today": "Hôm nay",
    "taskGroup.yesterday": "Hôm qua",
    "taskGroup.last7": "7 ngày qua",
    "taskGroup.older": "Lớn hơn",
    "taskGroup.searchResults": "Kết quả tìm kiếm",
    "taskGroup.active": "Tích cực",
    "taskGroup.running": "Đang chạy",
    "taskGroup.waiting": "Chờ",
    "taskGroup.dispatchPending": "Đang chỉ định một kênh khả dụng...",
    "taskGroup.expand": "Mở rộng {label}",
    "taskGroup.collapse": "Thu gọn {label}",
    "taskGroup.buttonLabel": "nhiệm vụ {label}, {count}",
    "archive.title": "Lưu trữ",
    "archive.empty": "Không có cuộc trò chuyện nào được lưu trữ",
    "archive.count": "{count} cuộc trò chuyện đã lưu trữ",
    "archive.restore": "Khôi phục",
    "archive.archiveFailed": "Lưu trữ không thành công",
    "archive.restoreFailed": "Khôi phục không thành công",
    "archive.restored": "Đã khôi phục cuộc trò chuyện",
    "archive.archiving": "Đang lưu trữ...",
    "archive.restoring": "Đang khôi phục...",
    "archive.deleting": "Đang xóa...",
    "archive.restoredCount": "Đã khôi phục {count} nhiệm vụ",
    "settings.title": "Kho",
    "settings.status": "Khởi động lại WebUI sau khi lưu đường dẫn lưu trữ",
    "settings.inputRoot": "Thư mục đầu vào",
    "settings.outputRoot": "Thư mục đầu ra",
    "settings.galleryRoot": "Thư mục thư viện",
    "settings.sourceDataRoot": "Thư mục dữ liệu nguồn",
    "settings.chooseDirectory": "Chọn thư mục",
    "settings.language": "Ngôn ngữ giao diện",
    "settings.languageCopy": "Lần đầu mở tool, giao diện dùng tiếng Việt. Lựa chọn ngôn ngữ thủ công sẽ được ghi nhớ.",
    "settings.notificationsCopy": "Thông báo khi nhiệm vụ hoàn thành hoặc thất bại.",
    "settings.inAppNotification": "Thông báo trong ứng dụng",
    "settings.systemNotification": "Thông báo hệ thống",
    "settings.save": "Lưu cài đặt",
    "settings.loadFailed": "Không tải được cài đặt",
    "settings.saveFailed": "Không lưu được cài đặt",
    "settings.savedRestart": "Đã lưu cài đặt bộ nhớ.",
    "settings.saved": "Đã lưu",
    "settings.savedRestartStatus": "Đã lưu cài đặt bộ nhớ.",
    "systemSettings.title": "Cài đặt hệ thống",
    "systemSettings.tabsLabel": "Các mục cài đặt hệ thống",
    "systemSettings.apiTab": "Cài đặt API",
    "systemSettings.codexTab": "Kênh Codex",
    "systemSettings.languageTab": "Ngôn ngữ",
    "systemSettings.storageTab": "Thông báo",
    "languageSettings.instantStatus": "Thay đổi ngôn ngữ áp dụng ngay lập tức",
    "apiSettings.title": "Cài đặt API",
    "apiSettings.status": "Cài đặt đã lưu áp dụng ngay lập tức ở chế độ API",
    "apiSettings.codexMode": "kênh codex",
    "apiSettings.codexImages": "Hình ảnh",
    "apiSettings.codexResponses": "Phản hồi",
    "apiSettings.providers": "Nhà cung cấp API",
    "apiSettings.providerCount": "{count} nhà cung cấp",
    "apiSettings.provider": "nhà cung cấp",
    "apiSettings.providerName": "Tên nhà cung cấp",
    "apiSettings.newProviderAction": "Nhà cung cấp mới",
    "apiSettings.copyProvider": "Sao chép",
    "apiSettings.copyProviderName": "{name} Sao chép",
    "apiSettings.copyProviderStatus": "Nhà cung cấp đã sao chép bằng khóa đã lưu của nó.",
    "apiSettings.copyProviderWithoutKeyStatus": "Đã sao chép nhà cung cấp.",
    "apiSettings.sortProviders": "Sắp xếp",
    "apiSettings.finishSortProviders": "Xong",
    "apiSettings.sortProviderModeStatus": "Sắp xếp nhà cung cấp",
    "apiSettings.sortProviderStatus": "Đơn đặt hàng của nhà cung cấp đã thay đổi.",
    "apiSettings.moveProviderUp": "Hướng lên",
    "apiSettings.moveProviderDown": "Xuống",
    "apiSettings.moveProviderUpAria": "Di chuyển {provider} lên",
    "apiSettings.moveProviderDownAria": "Di chuyển {provider} xuống",
    "apiSettings.mode": "Chế độ yêu cầu",
    "apiSettings.images": "API hình ảnh trực tiếp",
    "apiSettings.responses": "API phản hồi",
    "apiSettings.modeImagesShort": "Trực tiếp",
    "apiSettings.imageModel": "Mô hình hình ảnh",
    "apiSettings.concurrency": "Giới hạn đồng thời của nhà cung cấp",
    "apiSettings.concurrencyShort": "Đồng thời",
    "apiSettings.concurrencyValue": "giới hạn đồng thời {concurrency}",
    "apiSettings.keySaved": "Đã lưu khóa API",
    "apiSettings.keyNotSet": "Khóa API chưa được đặt",
    "apiSettings.editProvider": "Chỉnh sửa nhà cung cấp",
    "apiSettings.newProviderTitle": "Nhà cung cấp mới",
    "apiSettings.editHint": "Nhà cung cấp lưu ghi bản chỉnh sửa này vào phần phụ trợ.",
    "apiSettings.finishEditFirst": "Lưu hoặc hủy chỉnh sửa nhà cung cấp hiện tại trước",
    "apiSettings.newDraftStatus": "Tạo nhà cung cấp.",
    "apiSettings.editDraftStatus": "Nhà cung cấp chỉnh sửa",
    "apiSettings.cancelEdit": "Hủy chỉnh sửa",
    "apiSettings.saveProvider": "Lưu nhà cung cấp",
    "apiSettings.saveSelection": "Lưu lựa chọn",
    "apiSettings.deleteProviderTitle": "Xóa nhà cung cấp?",
    "apiSettings.deleteProviderMessage": "Xóa \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Điều này loại bỏ nó khỏi danh sách nhà cung cấp.",
    "apiSettings.deleteProviderStatus": "Nhà cung cấp đã bị xóa.",
    "apiSettings.save": "Lưu cài đặt API",
    "apiSettings.loadFailed": "Không tải được cài đặt API",
    "apiSettings.savedKeyPlaceholder": "Khóa API được lưu ở phần phụ trợ.",
    "apiSettings.newProvider": "Nhà cung cấp mới",
    "apiSettings.saving": "Đang lưu...",
    "apiSettings.savingStatus": "Đang lưu cài đặt API...",
    "apiSettings.saveFailed": "Không lưu được cài đặt API",
    "apiSettings.savedSummary": "Đã lưu · Codex {codex} · API {provider} · {mode} · {model} · đồng thời {concurrency}",
    "apiSettings.savedShort": "Đã lưu",
    "apiSettings.savedStatus": "Đã lưu cài đặt API",
    "apiSettings.saveFailedShort": "Lưu không thành công",
    "codexSettings.title": "Kênh Codex",
    "codexSettings.status": "Chọn kênh tạo để đăng nhập Codex cục bộ",
    "codexSettings.notesLabel": "Ghi chú kênh Codex",
    "codexSettings.imagesTitle": "Hình ảnh",
    "codexSettings.imagesCopy": "Kênh mặc định để truyền trực tiếp các tham số kích thước, chất lượng và chỉnh sửa.",
    "codexSettings.responsesTitle": "Phản hồi",
    "codexSettings.responsesCopy": "Kênh tương thích cho các quy trình công việc cần công cụ tìm kiếm trên web.",
    "codexSettings.save": "Lưu kênh Codex",
    "imageEditor.title": "Chỉnh sửa hình ảnh đầu vào",
    "imageEditor.promptHint": "Các mũi tên và dấu vẽ tay trong ảnh chỉ mang tính chất hướng dẫn.",
    "imageEditor.inputFallback": "Hình ảnh đầu vào",
    "imageEditor.openFailed": "Không thể mở hình ảnh này để chỉnh sửa",
    "imageEditor.loadForEditFailed": "Không thể tải hình ảnh này để chỉnh sửa",
    "imageEditor.canvasCreateFailed": "Không tạo được canvas chỉnh sửa hình ảnh",
    "imageEditor.closedRegionRequired": "Sử dụng cọ để vẽ vùng kín trước",
    "imageEditor.saveFailed": "Không lưu được chỉnh sửa hình ảnh",
    "imageEditor.saved": "Đã lưu hình ảnh đầu vào đã chỉnh sửa",
    "imageEditor.uneditable": "Hình ảnh này không thể được chỉnh sửa",
    "imageEditor.resetDone": "Đặt lại về ảnh gốc",
    "imageEditor.resetFailed": "Không thể đặt lại ảnh gốc",
    "imageEditor.subtitle": "Cắt, vẽ, điền hoặc thêm mũi tên, sau đó lưu làm hình ảnh đầu vào mới",
    "imageEditor.toolbar": "Thanh công cụ chỉnh sửa hình ảnh",
    "imageEditor.tools": "Công cụ",
    "imageEditor.select": "Lựa chọn",
    "imageEditor.brush": "Chải",
    "imageEditor.arrow": "Mũi tên",
    "imageEditor.crop": "Mùa vụ",
    "imageEditor.fill": "Đổ đầy",
    "imageEditor.fillLabel": "Đổ đầy thùng sơn",
    "imageEditor.eraser": "Cục tẩy",
    "imageEditor.colors": "Màu sắc",
    "imageEditor.red": "Màu đỏ",
    "imageEditor.blue": "Màu xanh da trời",
    "imageEditor.green": "Màu xanh lá",
    "imageEditor.yellow": "Màu vàng",
    "imageEditor.white": "Trắng",
    "imageEditor.black": "Đen",
    "imageEditor.customColor": "Màu tùy chỉnh",
    "imageEditor.stroke": "Đột quỵ",
    "imageEditor.history": "Lịch sử",
    "imageEditor.undo": "Hoàn tác",
    "imageEditor.redo": "Làm lại",
    "imageEditor.reset": "Đặt lại hình ảnh",
    "imageEditor.canvas": "Canvas chỉnh sửa hình ảnh",
    "imageEditor.canvasScope": "Phạm vi vải",
    "imageEditor.canvasScopeBase": "Hình ảnh cơ sở",
    "imageEditor.canvasScopeFit": "Lớp phù hợp",
    "imageEditor.canvasFitDone": "Canvas bây giờ vừa với các lớp",
    "imageEditor.canvasBaseDone": "Canvas được khôi phục về hình ảnh cơ sở",
    "imageEditor.insertImages": "Chèn hình ảnh",
    "imageEditor.layers": "Lớp",
    "imageEditor.layerUp": "Di chuyển lên",
    "imageEditor.layerDown": "Di chuyển xuống",
    "imageEditor.emptyInsertList": "Không có hình ảnh đầu vào khác",
    "imageEditor.selectLayerFirst": "Chọn một lớp đầu tiên",
    "imageEditor.baseLayer": "Hình ảnh cơ sở",
    "gallery.title": "Phòng trưng bày",
    "gallery.subtitle": "Chọn hình ảnh tham khảo cho nhiệm vụ hiện tại",
    "gallery.manageCategories": "Quản lý danh mục",
    "gallery.categoryManager": "Quản lý danh mục thư viện",
    "gallery.categoryManagement": "Quản lý danh mục",
    "gallery.categoryCopy": "Danh mục được lưu vào thư viện;",
    "gallery.newCategoryName": "Tên danh mục mới",
    "gallery.newCategoryRole": "Vai trò nhắc nhở, ví dụ:",
    "gallery.addCategory": "Thêm danh mục",
    "gallery.drawerSubtitle": "Danh mục hiện tại: {category}.",
    "gallery.emptyCategory": "Chưa có hình ảnh nào trong danh mục này",
    "gallery.dragSort": "Kéo để sắp xếp",
    "gallery.dragSortImage": "Kéo sắp xếp hình ảnh {name}",
    "gallery.dragSortCategory": "Danh mục sắp xếp kéo {name}",
    "gallery.use": "Sử dụng",
    "gallery.replace": "Thay thế",
    "gallery.rename": "Đổi tên",
    "gallery.moveCategory": "Loại",
    "gallery.note": "Ghi chú",
    "gallery.delete": "Xóa bỏ",
    "gallery.uncategorized": "Chưa được phân loại",
    "addGallery.title": "Thêm vào thư viện",
    "addGallery.copy": "Tên là duy nhất trên toàn cầu và có thể được tham chiếu bằng @name sau",
    "addGallery.name": "Tên",
    "addGallery.namePlaceholder": "Ví dụ: Mia",
    "addGallery.category": "Loại",
    "addGallery.note": "Ghi chú tham khảo",
    "addGallery.notePlaceholder": "Ví dụ: chỉ tham chiếu khuôn mặt và tóc, không tham chiếu quần áo hay hình nền",
    "addGallery.save": "Lưu vào thư viện",
    "close.promptTemplates": "Đóng bảng mẫu lời nhắc",
    "close.archive": "Đóng bảng lưu trữ",
    "close.settings": "Đóng bảng cài đặt bộ nhớ",
    "close.apiSettings": "Đóng bảng cài đặt API",
    "close.systemSettings": "Đóng bảng cài đặt hệ thống",
    "close.imageEditor": "Đóng bảng chỉnh sửa hình ảnh",
    "close.gallery": "Đóng bảng thư viện",
    "close.addGallery": "Đóng thêm vào bảng thư viện",
    "close.version": "Đóng bảng cập nhật phiên bản",
    "apiSettings.baseUrlLabel": "Địa chỉ cơ sở",
    "apiSettings.apiKeyLabel": "Khóa API",
    "apiSettings.gatewayProvider": "Thêm Gateway HVD AI",
    "apiSettings.gatewayName": "Gateway HVD AI",
    "apiSettings.gatewayDraftStatus": "Đã nạp cấu hình Gateway. Hãy dán gateway client key trước khi lưu.",
    "apiSettings.gatewayHint": "Gateway dùng client key riêng, ví dụ gw_app_.... Không nhập khóa provider hoặc khóa quản trị."
};


